import { buildEndpoint } from './endpointUtils';
import isEmpty from 'lodash/isEmpty';
import store from '../store';
import { MessageType } from '../constants/createSegment';
import { SESSION_TIMED_OUT } from '../constants/messages';
import { getStageSpecificCognitoAuthSettings } from './envUtils';
import { SHOW_NOTIFICATON } from '../actions/notificationActionsType';

export default async function fetchWithRetry(url, params, sessionIdToken, retries) {
  const endpoint = buildEndpoint(url);
  const storage = window['sessionStorage'];
  const token = isEmpty(sessionIdToken) ? storage.getItem('idToken') : sessionIdToken;

  const response = await fetch(endpoint, {
    ...params,
    mode: 'cors',
    headers: {
      ...params?.headers,
      Authorization: token,
    },
  });

  responseInterceptor(response);

  if (retries > 0 && (!response.ok || response.status >= 500)) {
    return fetchWithRetry(url, params, sessionIdToken, retries - 1);
  }

  return response;
}

function responseInterceptor(response) {
  if (response?.status === 401 || response?.data?.message === '401 Unauthorized') {
    store.dispatch({
      type: SHOW_NOTIFICATON,
      payload: {
        message: SESSION_TIMED_OUT,
        timeout: 10000,
        type: MessageType.ERROR,
      },
    });

    setTimeout(() => {
      window.location.replace(getStageSpecificCognitoAuthSettings()?.RedirectUriSignIn);
    }, 5000);
  }
}
